module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Air Freight Import")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.ffExoprtDetail.allModuleId ? this.ffExoprtDetail.allModuleId : '',
      "jobSeriesBanner": this.ffExoprtDetail.airImportSeries ? this.ffExoprtDetail.airImportSeries : '',
      "bannerClientName": this.multipleHouseBLData[0].ImporterName ? this.multipleHouseBLData[0].ImporterName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select",
      "isDisabled": _vm.ffExoprtDetail.ffairImportId == '' ? false : true
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "airlineId"
    }
  }, [_vm._v("AirLine Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.shippingList,
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select AirLine "
    },
    model: {
      value: (_vm.ffExoprtDetail.airlineId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airlineId", $$v)
      },
      expression: "ffExoprtDetail.airlineId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Date of Flight")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "sailDate",
      "name": "sailDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.flightDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "flightDate", $$v)
      },
      expression: "ffExoprtDetail.flightDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Pre-Alert Received Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "alertReceivedDate",
      "name": "alertReceivedDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.alertReceivedDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "alertReceivedDate", $$v)
      },
      expression: "ffExoprtDetail.alertReceivedDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [(!_vm.ffExoprtDetail.containerInfo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.containerInfo))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [(!_vm.ffExoprtDetail.airlineId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.airlineId))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [(!_vm.ffExoprtDetail.flightDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.flightDate))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [(!_vm.ffExoprtDetail.alertReceivedDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.alertReceivedDate))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.IcdPOrtListNew,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORlocationId", $$v)
      },
      expression: "ffExoprtDetail.PORlocationId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Airport of Departure")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'getPortDischargeList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PODLocationId", $$v)
      },
      expression: "ffExoprtDetail.PODLocationId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("ETD @ Origin Port")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "etaDischargePort",
      "name": "etaDischargePort"
    },
    model: {
      value: (_vm.ffExoprtDetail.etaDischargePort),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "etaDischargePort", $$v)
      },
      expression: "ffExoprtDetail.etaDischargePort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [(!_vm.ffExoprtDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PORlocationId))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffExoprtDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.LPlocationId))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Airport of Arrival")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Arrival Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "LPlocationId", $$v)
      },
      expression: "ffExoprtDetail.LPlocationId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalPlaceLocationId", $$v)
      },
      expression: "ffExoprtDetail.finalPlaceLocationId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("ETA @ Arrival Port")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "etaArrivalPort",
      "name": "etaArrivalPort"
    },
    model: {
      value: (_vm.ffExoprtDetail.etaArrivalPort),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "etaArrivalPort", $$v)
      },
      expression: "ffExoprtDetail.etaArrivalPort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(!_vm.ffExoprtDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PODLocationId))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.finalPlaceLocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', [_vm._v("Flight No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselVoyage",
      "name": "vesselVoyage"
    },
    model: {
      value: (_vm.ffExoprtDetail.vesselVoyage),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "vesselVoyage", $$v)
      },
      expression: "ffExoprtDetail.vesselVoyage"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('label', [_vm._v("Pre Carriage By")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "preCarriageBy",
      "name": "preCarriageBy"
    },
    model: {
      value: (_vm.ffExoprtDetail.preCarriageBy),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "preCarriageBy", $$v)
      },
      expression: "ffExoprtDetail.preCarriageBy"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Marks & Nos.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "marksNos",
      "name": "marksNos"
    },
    model: {
      value: (_vm.ffExoprtDetail.marksNos),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "marksNos", $$v)
      },
      expression: "ffExoprtDetail.marksNos"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Description of Goods")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "descriptionGood",
      "name": "descriptionGood"
    },
    model: {
      value: (_vm.ffExoprtDetail.descriptionGood),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "descriptionGood", $$v)
      },
      expression: "ffExoprtDetail.descriptionGood"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', [_vm._v("Commodity Name, HSN Code and Type")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "commodity",
      "name": "commodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.commodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodity", $$v)
      },
      expression: "ffExoprtDetail.commodity"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Total No. Of Packages")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.noOfPkg),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "noOfPkg", $$v)
      },
      expression: "ffExoprtDetail.noOfPkg"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Gross Wgt. of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeightCargo",
      "name": "grossWeightCargo"
    },
    model: {
      value: (_vm.ffExoprtDetail.grossWeightCargo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "grossWeightCargo", $$v)
      },
      expression: "ffExoprtDetail.grossWeightCargo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Volume Wgt. of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.ffExoprtDetail.volumeWeightCargo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "volumeWeightCargo", $$v)
      },
      expression: "ffExoprtDetail.volumeWeightCargo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Final Chargeable Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.ffExoprtDetail.finalChargeableWeight),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalChargeableWeight", $$v)
      },
      expression: "ffExoprtDetail.finalChargeableWeight"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remarks",
      "name": "remarks"
    },
    model: {
      value: (_vm.ffExoprtDetail.ffExportremarks),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ffExportremarks", $$v)
      },
      expression: "ffExoprtDetail.ffExportremarks"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.containerInfo == 'Consolidation' && _vm.multipleHouseBLData.length > 0) ? _c('md-layout', {
    staticClass: "mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm"
    },
    on: {
      "click": _vm.showMoreShipper
    }
  }, [_vm._v(_vm._s(_vm.openShipper == true ? "Hide" : "Add More") + " House BL")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Importer Details( House B/L Wise)")])], 1), _vm._v(" "), (_vm.multipleHouseBLData.length == 0 || _vm.openShipper == true) ? _c('div', [_c('b-card', {
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    model: {
      value: (_vm.ffHouseBL.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "importerClientId", $$v)
      },
      expression: "ffHouseBL.importerClientId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name"
    },
    model: {
      value: (_vm.ffHouseBL.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "exporterClientId", $$v)
      },
      expression: "ffHouseBL.exporterClientId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [(!_vm.ffHouseBL.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.importerClientId))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), (!_vm.ffHouseBL.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.exporterClientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.ffHouseBL.notifyList), function(singleInput, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "35"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "60"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Name & Address")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "70"
      }
    }, [_c('quill-editor', {
      ref: "myTextEditor",
      refInFor: true,
      model: {
        value: (singleInput.inputValue),
        callback: function($$v) {
          _vm.$set(singleInput, "inputValue", $$v)
        },
        expression: "singleInput.inputValue"
      }
    })], 1)], 1)], 1)
  })), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.addNotify
    }
  }, [_vm._v("Add Notify")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Air B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "secondBLNumber",
      "name": "secondBLNumber"
    },
    model: {
      value: (_vm.ffHouseBL.secondBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLNumber", $$v)
      },
      expression: "ffHouseBL.secondBLNumber"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("B/L Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "secondBLDate",
      "name": "secondBLDate"
    },
    model: {
      value: (_vm.ffHouseBL.secondBLDate),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLDate", $$v)
      },
      expression: "ffHouseBL.secondBLDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "secondBlType"
    }
  }, [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type"
    },
    model: {
      value: (_vm.ffHouseBL.secondBlType),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBlType", $$v)
      },
      expression: "ffHouseBL.secondBlType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary mt-3",
    attrs: {
      "id": "permitted1",
      "name": "permitted1",
      "md-value": "Original"
    },
    model: {
      value: (_vm.ffHouseBL.secondBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLRadio", $$v)
      },
      expression: "ffHouseBL.secondBLRadio"
    }
  }, [_vm._v("Original")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "seaWayBl"
    },
    model: {
      value: (_vm.ffHouseBL.secondBLRadio),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLRadio", $$v)
      },
      expression: "ffHouseBL.secondBLRadio"
    }
  }, [_vm._v("Sea Way")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "secondOcFreghtTerms"
    }
  }, [_vm._v("Air Freight")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.oceanFreightTermsList,
      "option-value": "oceanFreightTermsVal",
      "option-text": "oceanFreightTermsText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffHouseBL.secondOcFreghtTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondOcFreghtTerms", $$v)
      },
      expression: "ffHouseBL.secondOcFreghtTerms"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (!_vm.ffHouseBL.secondBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.secondBLNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload B/L")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "secondBLupload",
      "id": "secondBLupload",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangeSecondBl
    },
    model: {
      value: (_vm.ffHouseBL.secondBLupload),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "secondBLupload", $$v)
      },
      expression: "ffHouseBL.secondBLupload"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.SecondBlUploadView.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.SecondBlUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Air_Import_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document -\n                      " + _vm._s(index + 1))])])
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.ffHouseBL.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "deliveryTerms", $$v)
      },
      expression: "ffHouseBL.deliveryTerms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("Custom Clearence Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select  Type"
    },
    model: {
      value: (_vm.ffHouseBL.ccType),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "ccType", $$v)
      },
      expression: "ffHouseBL.ccType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffHouseBL.ccType == 'Outsourced') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffHouseBL.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "ccCha", $$v)
      },
      expression: "ffHouseBL.ccCha"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), (!_vm.ffHouseBL.ccType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.ccType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryModeList,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Delivery Mode"
    },
    model: {
      value: (_vm.ffHouseBL.houseDeliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseDeliveryMode", $$v)
      },
      expression: "ffHouseBL.houseDeliveryMode"
    }
  })], 1), _vm._v(" "), (_vm.ffHouseBL.houseDeliveryMode == 'DOOR') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffHouseBL.houseDeliveryMode == 'DOOR') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Door FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.allLocationList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    model: {
      value: (_vm.ffHouseBL.doorFPOd),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "doorFPOd", $$v)
      },
      expression: "ffHouseBL.doorFPOd"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("Source Of Booking")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipTypeList,
      "option-value": "shipTypeVal",
      "option-text": "shipTypeText",
      "placeholder": "Select Source Of Booking "
    },
    model: {
      value: (_vm.ffHouseBL.shipType),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "shipType", $$v)
      },
      expression: "ffHouseBL.shipType"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffHouseBL.shipType == 'Destination') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentNameList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    model: {
      value: (_vm.ffHouseBL.agentName),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "agentName", $$v)
      },
      expression: "ffHouseBL.agentName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Origin') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "sourceOriginclientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.ffHouseBL.sourceOriginclientId),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "sourceOriginclientId", $$v)
      },
      expression: "ffHouseBL.sourceOriginclientId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Destination') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Buyer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyer",
      "name": "buyer"
    },
    model: {
      value: (_vm.ffHouseBL.buyer),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "buyer", $$v)
      },
      expression: "ffHouseBL.buyer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Origin') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Enter Buying House")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyingHouse",
      "name": "buyingHouse"
    },
    model: {
      value: (_vm.ffHouseBL.buyingHouse),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "buyingHouse", $$v)
      },
      expression: "ffHouseBL.buyingHouse"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffHouseBL.shipType == 'Origin') ? _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Other Specify")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherSpecify",
      "name": "otherSpecify"
    },
    model: {
      value: (_vm.ffHouseBL.otherSpecify),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "otherSpecify", $$v)
      },
      expression: "ffHouseBL.otherSpecify"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Marks & Nos.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseMarksNos",
      "name": "houseMarksNos"
    },
    model: {
      value: (_vm.ffHouseBL.houseMarksNos),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseMarksNos", $$v)
      },
      expression: "ffHouseBL.houseMarksNos"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', [_vm._v("Container No./ Seal No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseContainerSealNo",
      "name": "houseContainerSealNo"
    },
    model: {
      value: (_vm.ffHouseBL.houseContainerSealNo),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseContainerSealNo", $$v)
      },
      expression: "ffHouseBL.houseContainerSealNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Commodity Name, HSN Code and Type")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseCommodity",
      "name": "houseCommodity"
    },
    model: {
      value: (_vm.ffHouseBL.houseCommodity),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseCommodity", $$v)
      },
      expression: "ffHouseBL.houseCommodity"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Total No. Of Packages")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseNoOfPkg",
      "name": "houseNoOfPkg"
    },
    model: {
      value: (_vm.ffHouseBL.houseNoOfPkg),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseNoOfPkg", $$v)
      },
      expression: "ffHouseBL.houseNoOfPkg"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Gross Wgt. of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseGrossWeightCargo",
      "name": "houseGrossWeightCargo"
    },
    model: {
      value: (_vm.ffHouseBL.houseGrossWeightCargo),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseGrossWeightCargo", $$v)
      },
      expression: "ffHouseBL.houseGrossWeightCargo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Volume Wgt. of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.ffHouseBL.houseVolumeWeightCargo),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseVolumeWeightCargo", $$v)
      },
      expression: "ffHouseBL.houseVolumeWeightCargo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Final Chargeable Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.ffHouseBL.houseFinalChargeableWeight),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseFinalChargeableWeight", $$v)
      },
      expression: "ffHouseBL.houseFinalChargeableWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Description of Goods")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "houseDescriptionGood",
      "name": "houseDescriptionGood"
    },
    model: {
      value: (_vm.ffHouseBL.houseDescriptionGood),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "houseDescriptionGood", $$v)
      },
      expression: "ffHouseBL.houseDescriptionGood"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remarks",
      "name": "remarks"
    },
    model: {
      value: (_vm.ffHouseBL.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ffHouseBL, "remarks", $$v)
      },
      expression: "ffHouseBL.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "info",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addFFSeaImport('')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multipleHouseBLData.length > 0) ? _c('table', {
    staticClass: "table table-bordered gutr",
    attrs: {
      "id": "conBooking"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("Importer Name")]), _vm._v(" "), _c('th', [_vm._v("Exporter Name")]), _vm._v(" "), _c('th', [_vm._v("House BL Number")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipleHouseBLData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ImporterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ExporterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.secondBLNumber))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-info"
      },
      on: {
        "click": function($event) {
          _vm.EditHouseBL(item1)
        }
      }
    }, [_vm._v("Edit")])], 1)])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.multipleHouseBLData.length > 0 && _vm.ffHouseBL.ffAirMultiBlId == '') ? _c('md-layout', {
    staticClass: "mrgtop-button gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addFFSeaImport('fdsf')
      }
    }
  }, [_vm._v("Save &\n              Proceed to Execution")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddSeaImp
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c07ca9a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airImport/ffairImportFcl.vue
// module id = 2538
// module chunks = 0